import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * UpsellCard — a cross-promo for another Fantasy Taco product. Dropped at
 * high-traffic moments (after a vote, after creating a draft, the bid waiting
 * room) to convert visitors into the simulator / manager intel funnels.
 */
const UpsellCard = ({ wordmark, title, body, cta, to, icon: Icon, onClick, compact = false }) => {
  const navigate = useNavigate();
  const iconSize = compact ? 32 : 44;
  return (
    <div
      className="ft-card"
      style={{ padding: compact ? '14px 16px' : '20px 22px', display: 'flex', gap: compact ? 12 : 16, alignItems: 'center', flexWrap: 'wrap' }}
    >
      {Icon && (
        <div
          style={{
            width: iconSize,
            height: iconSize,
            borderRadius: compact ? 9 : 12,
            background: 'var(--ft-surface-hover)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flex: 'none',
            color: 'var(--ft-ink)',
          }}
        >
          <Icon width={compact ? 16 : 22} height={compact ? 16 : 22} />
        </div>
      )}
      <div style={{ flex: 1, minWidth: compact ? 140 : 220 }}>
        <span className="ft-k brand" style={compact ? { fontSize: 9.5 } : undefined}>{wordmark}</span>
        <div style={{ fontSize: compact ? 14 : 17, fontWeight: 600, letterSpacing: '-0.01em', margin: compact ? '4px 0 2px' : '6px 0 4px' }}>{title}</div>
        {!compact && <p className="ft-sub" style={{ fontSize: 13.5, margin: 0 }}>{body}</p>}
      </div>
      <button className="ft-btn sm" style={{ flex: 'none', ...(compact ? { padding: '8px 16px', fontSize: 12.5 } : null) }} onClick={() => { if (onClick) onClick(); navigate(to); }}>
        {cta}
      </button>
    </div>
  );
};

export default UpsellCard;
